var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-component',{attrs:{"data":_vm.timeclocks,"headers":_vm.headers,"pagination":_vm.pagination,"rowActions":_vm.rowActions,"loading":_vm.loading,"colors":_vm.colors},on:{"filterParams":_vm.filter,"changePagination":_vm.onChangePage}})}
var staticRenderFns = []

export { render, staticRenderFns }